import { render, staticRenderFns } from "./SchoolTeamsHomePreview.vue?vue&type=template&id=1b99c3d6&scoped=true&"
import script from "./SchoolTeamsHomePreview.vue?vue&type=script&lang=js&"
export * from "./SchoolTeamsHomePreview.vue?vue&type=script&lang=js&"
import style0 from "./SchoolTeamsHomePreview.vue?vue&type=style&index=0&id=1b99c3d6&lang=less&scoped=true&"
import style1 from "./SchoolTeamsHomePreview.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b99c3d6",
  null
  
)

export default component.exports